export default __webpack_public_path__ + "static/media/Icons_LOG OUT.b723130c.svg";